var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fw-form-input__wrapper",class:{ "h-flex-1-0": _vm.flexAutoWidth },style:({ width: _vm.width })},[_c('label',{staticClass:"fw-form-input__label",class:[
            _vm.labelType,
            _vm.labelClass,
            {
                "fw-form-input-label--error": _vm.fieldHasError
            }]},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }